import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Master from "./layout/Master";
import {VirtualHost, REACT_PATH} from "./constants"
import {request} from "./helper/APIUtils";

import axios from 'axios';
import {API_BASE_URL} from './constants';
axios.defaults.baseURL = API_BASE_URL;

request({url: `/virtual/conf`})
  .then(response => {
    VirtualHost.conf = response.data;
    ReactDOM.render(
      <Router basename={REACT_PATH} keySize={36}>
        <Master />
      </Router>,
      document.getElementById('react'));
    });
